<div class="dialog-header">
    <h2>{{data.isResponsiblePerson ? 'Select Responsible Person' : (data.isEdit ? 'Edit' : 'Add') + ' Signatory'}}</h2>
    <ng-icon name="heroXMark" mat-dialog-close class="cursor-pointer"></ng-icon>
</div>
<mat-divider></mat-divider>
<form [formGroup]="signatoryForm" (ngSubmit)="add()">
    <mat-dialog-content>
        <div *ngIf="data.isResponsiblePerson">
            Please select a responsible person for this obligation:
        </div>
        <div *ngIf="!data.isResponsiblePerson">
            Please {{data.isEdit ? 'edit' : 'add'}} the signatory details below:
        </div>
        <!-- <div class="w-100">
            <mat-form-field appearance="outline" class="w-100 p-2">
                <mat-label>Name</mat-label>
                <input type="text" matInput formControlName="name" autocomplete="off" />
                <mat-error *ngIf="signatoryForm.get('name').hasError('required')">
                    Name is required
                </mat-error>
            </mat-form-field>
        </div>
        <div class="w-100 ">
            <mat-form-field appearance="outline" class="w-100 p-2">
                <mat-label>Email Address</mat-label>
                <input type="email" matInput formControlName="email" autocomplete="off" />
                <mat-error *ngIf="signatoryForm.get('email').hasError('required')">
                    Email Address is required
                </mat-error>
                <mat-error *ngIf="signatoryForm.get('email').hasError('email')">
                    Please enter a valid Email Address
                </mat-error>
            </mat-form-field>
        </div> -->
        <div class="w-100" *ngIf="!data.isEdit">
            <mat-form-field appearance="outline" class="w-100 py-2">
                <mat-label>Select User</mat-label>
                <mat-select formControlName="users" [errorStateMatcher]="matcher" [multiple]="!data.isResponsiblePerson">
                    <mat-option *ngFor="let user of users" [value]="user.id">
                        {{ user.firstName + (user.middleName ? ' ' + user.middleName + ' ' : ' ') + user.lastName }}
                    </mat-option>
                </mat-select>
                <mat-error *ngIf="data.isResponsiblePerson && signatoryForm.get('users').hasError('required')">
                    Please select a responsible person
                </mat-error>
            </mat-form-field>
        </div>
        <div formArrayName="additionalSignatories" class="additional-signatories" *ngIf="!data.isResponsiblePerson">
            <div class="d-flex justify-content-between align-items-center mb-2">
                <h3 class="mb-0">{{data.isEdit ? 'Edit Signatory Details' : 'Additional Signatories'}}</h3>
                <button *ngIf="!data.isEdit" type="button" mat-raised-button color="primary" (click)="addSignatory()">
                    <mat-icon>add</mat-icon> Add Signatory
                </button>
            </div>

            <div *ngFor="let signatory of additionalSignatories.controls; let i=index" [formGroupName]="i" class="signatory-row">
                <div class="d-flex flex-column gap-2">
                    <mat-form-field appearance="outline" class="w-100 my-2">
                        <mat-label>Name</mat-label>
                        <input matInput formControlName="name" placeholder="Enter name">
                        <mat-error *ngIf="signatory.get('name').hasError('required')">
                            Name is required
                        </mat-error>
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="w-100">
                        <mat-label>Email</mat-label>
                        <input matInput formControlName="email" placeholder="Enter email">
                        <mat-error *ngIf="signatory.get('email').hasError('required')">
                            Email is required
                        </mat-error>
                        <mat-error *ngIf="signatory.get('email').hasError('email')">
                            Please enter a valid email
                        </mat-error>
                    </mat-form-field>
                    
                    <button *ngIf="!data.isEdit" 
                            type="button" 
                            mat-icon-button 
                            color="warn" 
                            (click)="removeSignatory(i)" 
                            class="align-self-end">
                        <mat-icon>delete</mat-icon>
                    </button>
                </div>
            </div>
        </div>

    </mat-dialog-content>
    <mat-divider></mat-divider>
    <mat-dialog-actions align="end">
        <button mat-raised-button mat-dialog-close color="primary" class="outlined-btn">Cancel</button>
        <button color="accent" 
                mat-raised-button 
                class="ml-3" 
                [disabled]="isLoading || (!data.isResponsiblePerson && !hasFormChanged()) || !signatoryForm.valid" 
                type="submit">
            {{data.isResponsiblePerson ? 'Select' : (data.isEdit ? 'Update' : 'Submit')}}
            <mat-icon matSuffix *ngIf="isLoading"><mat-spinner diameter="18"></mat-spinner></mat-icon>
        </button>
    </mat-dialog-actions>
</form>